module.exports = __webpack_public_path__ + "static/media/file-stats.aee10ad1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/file-stats.svg
// module id = 2862
// module chunks = 7